import { TD, TH } from "./table";

import { useArraySelector } from "hooks/redux_hooks";
import { useUserProfileProperties } from "hooks/use_user_properties";
import {
  BugReportSubmittedMonitoringEventType,
  MonitoringEventTypeType,
} from "shared/types/monitoring_event";
import { selectMonitoringEventsByType } from "store/selectors/monitoring";
import { formatDateTime } from "utils/date";
import { longDisplayName } from "utils/user";

function BugReportHeader() {
  return (
    <thead>
      <tr>
        <TH>User ID</TH>
        <TH>User Name</TH>
        <TH>Role</TH>
        <TH>Bug Report Text</TH>
        <TH>Date</TH>
        <TH>Submission URL</TH>
        <TH>Logs</TH>
      </tr>
    </thead>
  );
}

function BugReportBody() {
  const bugReportEvents = useArraySelector(
    selectMonitoringEventsByType(MonitoringEventTypeType.BUG_REPORT_SUBMITTED),
    ["id"],
  ) as BugReportSubmittedMonitoringEventType[];
  return (
    <tbody>
      {bugReportEvents.map((bugReportEvent) => {
        return <BugReportRow key={bugReportEvent.id} bugReportEvent={bugReportEvent} />;
      })}
    </tbody>
  );
}

function BugReportRow({
  bugReportEvent,
}: {
  bugReportEvent: BugReportSubmittedMonitoringEventType;
}) {
  const { userId, timestamp } = bugReportEvent;
  const { subject, submissionUrl, logsUrl } = bugReportEvent.contextData;
  const user = useUserProfileProperties(bugReportEvent.userId);

  const textSplit = subject.split(" -- ");
  const title = textSplit.slice(0, textSplit.length - 1).join(" -- ");
  const submissionURLPath = new URL(submissionUrl).pathname;
  return (
    <tr>
      <TD>{userId}</TD>
      <TD>{longDisplayName(user) || "(not enrolled in class)"}</TD>
      <TD>{user?.role || "-"}</TD>
      <TD>{title}</TD>
      <TD noWrap>{formatDateTime(timestamp)}</TD>
      <TD scrollX>
        <a href={submissionURLPath}>{submissionURLPath}</a>
      </TD>
      <TD>
        <a href={logsUrl}>link</a>
      </TD>
    </tr>
  );
}

function BugReportTable() {
  return (
    <table
      className="bug-reports fds-table table-hover"
      style={{ tableLayout: "auto" }}
      data-testid="bug-report-table"
    >
      <BugReportHeader />
      <BugReportBody />
    </table>
  );
}

export { BugReportHeader, BugReportBody, BugReportRow, BugReportTable };
